const useFilterChartData = (chartData: ChartPoint[]): ChartPoint[] => {
    const firstNonZeroIndex = chartData.findIndex((point) => point.price > 0);

    if (firstNonZeroIndex === -1) return [];

    return chartData.slice(firstNonZeroIndex);
  };

  export default useFilterChartData;
